/* SearchResultPage.styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _7 = "@media (min-width:64rem){._u5ggwd81{margin-block:var(--ds-space-400,2pc) var(--ds-space-200,1pc)}}";
const _6 = "._1p57u2gc{row-gap:var(--ds-space-100,8px)}";
const _5 = "._1n261g80{flex-wrap:wrap}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._1bah1yb4{justify-content:space-between}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._1moul4ej{margin-block:var(--ds-space-300,24px) var(--ds-space-200,1pc)}";
export const GridHeader = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1moul4ej _1e0c1txw _1bah1yb4 _4cvr1h6o _1n261g80 _1p57u2gc _u5ggwd81", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  GridHeader.displayName = 'GridHeader';
}